import React, { useState, useEffect } from 'react';

const INITIAL_FORM = {
  name: '', email: '', password: '', role: 'lojista',
  status: 'active', company_name: '', document: '', phone: '',
  permissions: { fretes: true, simulador_fretes: true, tokens_api: true, etiquetas: true },
};

const MODULES = [
  { key: 'fretes', label: 'Fretes', desc: 'Gerenciar transportadoras e credenciais' },
  { key: 'simulador_fretes', label: 'Simulador de Fretes', desc: 'Cotar fretes de teste no painel' },
  { key: 'tokens_api', label: 'Tokens de API', desc: 'Gerar e revogar chaves de integração' },
  { key: 'etiquetas', label: 'Emissão de Etiquetas', desc: 'Solicitar e emitir etiquetas de envio' },
];

export default function UserModal({ user, onSave, onClose }) {
  const isEdit = !!user;
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || '',
        email: user.email || '',
        password: '',
        role: user.role || 'lojista',
        status: user.status || 'active',
        company_name: user.companyName || user.company_name || '',
        document: user.document || '',
        phone: user.phone || '',
        permissions: {
          fretes: user.permissions?.fretes !== false,
          simulador_fretes: user.permissions?.simulador_fretes !== false,
          tokens_api: user.permissions?.tokens_api !== false,
          etiquetas: user.permissions?.etiquetas !== false,
        },
      });
    }
  }, [user]);

  function set(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
    setErrors((e) => ({ ...e, [field]: undefined }));
  }

  function togglePermission(key) {
    setForm((f) => ({ ...f, permissions: { ...f.permissions, [key]: !f.permissions[key] } }));
  }

  function validate() {
    const errs = {};
    if (!form.name.trim()) errs.name = 'Nome obrigatório';
    if (!form.email) errs.email = 'E-mail obrigatório';
    else if (!/\S+@\S+\.\S+/.test(form.email)) errs.email = 'E-mail inválido';
    if (!isEdit && !form.password) errs.password = 'Senha obrigatória';
    if (form.password && form.password.length < 6) errs.password = 'Mínimo 6 caracteres';
    return errs;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSaving(true);
    const payload = { ...form };
    if (!payload.password) delete payload.password;
    await onSave(payload, user?.id);
    setSaving(false);
  }

  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>{isEdit ? 'Editar Usuário' : 'Novo Usuário'}</h2>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} style={styles.form} noValidate>
          <div style={styles.grid2}>
            <Field label="Nome completo *" error={errors.name}>
              <input style={input(errors.name)} value={form.name} onChange={(e) => set('name', e.target.value)} placeholder="João Silva" />
            </Field>
            <Field label="E-mail *" error={errors.email}>
              <input style={input(errors.email)} type="email" value={form.email} onChange={(e) => set('email', e.target.value)} placeholder="joao@exemplo.com" />
            </Field>
          </div>

          <div style={styles.grid2}>
            <Field label={isEdit ? 'Nova senha (deixe em branco para manter)' : 'Senha *'} error={errors.password}>
              <input style={input(errors.password)} type="password" value={form.password} onChange={(e) => set('password', e.target.value)} placeholder="••••••••" />
            </Field>
            <Field label="Telefone">
              <input style={input()} value={form.phone} onChange={(e) => set('phone', e.target.value)} placeholder="(11) 99999-9999" />
            </Field>
          </div>

          <Field label="Nome da empresa">
            <input style={input()} value={form.company_name} onChange={(e) => set('company_name', e.target.value)} placeholder="Empresa LTDA" />
          </Field>

          <div style={styles.grid2}>
            <Field label="CPF / CNPJ">
              <input style={input()} value={form.document} onChange={(e) => set('document', e.target.value)} placeholder="00.000.000/0001-00" />
            </Field>
          </div>

          <div style={styles.grid2}>
            <Field label="Perfil">
              <select style={input()} value={form.role} onChange={(e) => set('role', e.target.value)}>
                <option value="lojista">Lojista</option>
                <option value="admin">Administrador</option>
              </select>
            </Field>
            <Field label="Status">
              <select style={input()} value={form.status} onChange={(e) => set('status', e.target.value)}>
                <option value="active">Ativo</option>
                <option value="pending">Pendente</option>
                <option value="inactive">Inativo</option>
                <option value="blocked">Bloqueado</option>
              </select>
            </Field>
          </div>

          {form.role === 'lojista' && (
            <div>
              <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Permissões de módulo</label>
              <div style={styles.permList}>
                {MODULES.map((mod) => (
                  <label key={mod.key} style={styles.permRow}>
                    <input
                      type="checkbox"
                      checked={form.permissions[mod.key]}
                      onChange={() => togglePermission(mod.key)}
                      style={{ marginTop: '2px' }}
                    />
                    <div>
                      <div style={styles.permLabel}>{mod.label}</div>
                      <div style={styles.permDesc}>{mod.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}

          <div style={styles.footer}>
            <button type="button" style={styles.btnCancel} onClick={onClose}>Cancelar</button>
            <button type="submit" style={styles.btnSave} disabled={saving}>
              {saving ? 'Salvando...' : isEdit ? 'Salvar alterações' : 'Criar usuário'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Field({ label, error, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>{label}</label>
      {children}
      {error && <span style={{ fontSize: '12px', color: '#dc2626' }}>{error}</span>}
    </div>
  );
}

function input(error) {
  return {
    padding: '9px 12px',
    border: `1.5px solid ${error ? '#dc2626' : '#e5e7eb'}`,
    borderRadius: '7px',
    fontSize: '14px',
    outline: 'none',
    background: error ? '#fef2f2' : '#f9fafb',
    fontFamily: 'inherit',
    color: '#111827',
    width: '100%',
  };
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '20px',
  },
  modal: {
    background: '#fff',
    borderRadius: '14px',
    width: '100%',
    maxWidth: '560px',
    boxShadow: '0 25px 50px rgba(0,0,0,0.2)',
    maxHeight: '90vh',
    overflow: 'auto',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #f3f4f6',
  },
  title: { fontSize: '18px', fontWeight: '700', color: '#111827' },
  closeBtn: {
    background: 'none', border: 'none', fontSize: '18px',
    cursor: 'pointer', color: '#6b7280', padding: '4px 8px',
    borderRadius: '4px',
  },
  form: { padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' },
  permList: { display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' },
  permRow: {
    display: 'flex', alignItems: 'flex-start', gap: '10px',
    padding: '10px 12px', borderRadius: '8px', background: '#f9fafb',
    border: '1px solid #f3f4f6', cursor: 'pointer',
  },
  permLabel: { fontSize: '13px', fontWeight: '600', color: '#111827' },
  permDesc: { fontSize: '12px', color: '#6b7280', marginTop: '2px' },
  footer: {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
    paddingTop: '8px', borderTop: '1px solid #f3f4f6',
  },
  btnCancel: {
    padding: '9px 18px', background: '#f9fafb',
    border: '1px solid #e5e7eb', borderRadius: '7px',
    fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit',
  },
  btnSave: {
    padding: '9px 20px',
    background: 'linear-gradient(135deg, #1e40af, #2563eb)',
    color: '#fff', border: 'none', borderRadius: '7px',
    fontSize: '14px', fontWeight: '600', cursor: 'pointer',
    fontFamily: 'inherit',
  },
};
